import * as React from 'react';
import * as styles from './styles.css';
import { Tags, ITagOption } from '@cian/ui-kit';

export interface ITagsListProps {
  options: ITagOption[];

  onClose(option: ITagOption): void;
}

export const TagsList: React.FC<ITagsListProps> = ({ options, onClose }) => {
  return (
    <div className={styles['wrapper']}>
      <Tags options={options} onClose={onClose} />
    </div>
  );
};

TagsList.displayName = 'TagsList';
